/* Nutriheal theme — collection and search facets.
   Desktop: the sidebar form submits itself shortly after a filter changes and the sort select
   submits on change. Mobile: the drawer keeps its explicit "Show results" button. Every update is a
   normal page load, so there is nothing to keep in sync and the URL stays shareable. */
(() => {
  'use strict';
  const desktop = window.matchMedia('(min-width: 990px)');
  let timer;

  function submit(form) {
    /* requestSubmit() runs constraint validation; an out-of-range price must not freeze the form. */
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) {
      form.removeAttribute('aria-busy');
      if (typeof form.reportValidity === 'function') form.reportValidity();
      return;
    }
    const message = form.dataset.announce;
    if (message && window.Nutriheal && typeof window.Nutriheal.announce === 'function') window.Nutriheal.announce(message);
    form.setAttribute('aria-busy', 'true');
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.submit();
  }

  document.addEventListener('change', (event) => {
    const field = event.target;
    const sortForm = field.closest('[data-sort-form]');
    if (sortForm) { submit(sortForm); return; }
    const form = field.closest('[data-facets-form]');
    if (!form || !desktop.matches || form.closest('dialog')) return;
    clearTimeout(timer);
    timer = setTimeout(() => submit(form), 250);
  });

  /* A field reported as invalid (by us or by the browser on a manual submit) means no navigation. */
  document.addEventListener('invalid', (event) => {
    const form = event.target.closest('[data-facets-form], [data-sort-form]');
    if (form) form.removeAttribute('aria-busy');
  }, true);

  /* Keep the URL clean: empty price fields are not sent. */
  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('[data-facets-form], [data-sort-form]')) return;
    form.querySelectorAll('input[type="number"]').forEach((input) => { if (input.value.trim() === '') input.disabled = true; });
  });

  /* Restore the forms when the page is served from the back/forward cache. */
  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;
    document.querySelectorAll('[data-facets-form], [data-sort-form]').forEach((form) => {
      form.removeAttribute('aria-busy');
      form.querySelectorAll('input[type="number"]:disabled').forEach((input) => { input.disabled = false; });
    });
  });
})();
